import { createRequestTypes } from 'common/websocket-redux';

export const GET_DEPENDENTS_REPORT = createRequestTypes(
  'admin/employer-reports/GET_DEPENDENTS_REPORT',
);
